export default "/images/494e8e19b9b90242623ac043c8354f00.avif";